import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import "../../../style/CounterpartyTicketview.css";
import * as ticketActions from "../../../modules/ticket/action";
import Loader from "../../Loader";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Modal from '@material-ui/core/Modal';
import { withStyles } from "@material-ui/core/styles";
import TicketPath from "../../../assets/images/ticket.png";
import { formatDate } from "../../../utils/DateFormatter";
import moment from "moment";
import { faArrowRight, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { green } from '@material-ui/core/colors';
const styles = theme => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: "white",
    boxShadow: "1px",
    padding: "20px",
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '16px'
  },
  exapansionPanel : {
    backgroundColor:'#00bc84',
    color:'white',
    marginTop:'15px'
  }
});

const CounterpartyTicketview = (props) => {
  const { classes } = props;
  const { CounterPartyTicketList, counterPartyTicketData, loader, ticketDataLoader, groupByValue, previousDaysvalue, pageData } = props;
  const [selectedHarvestYear, setSelectedHarvestYear] = useState(2025);
  const [pageNo, setPageNo] = useState(0);
  const [totalCount, setTotalCount] = useState(5);
  const [expandePanel, setexpandePanel] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [farmId, setFarmId] = useState(4);
  const [ele, setEle] = useState({});

  useEffect(() => {
    props.actions.setGroupByAction(groupByValue || "Truckline")
    props.actions.setPreviousDaysAction(previousDaysvalue || 7)
    props.actions.getCounterPartyTicketList("Truckline");
  }, []);
useEffect(()=>{
 props.actions.getTicketsForCounterParty(farmId,selectedHarvestYear,totalCount,pageNo,groupByValue, previousDaysvalue)
},[previousDaysvalue])
  const handleExapnaionPanel = (name,farm) => (event,expanded) => {
    setSelectedHarvestYear(farm.harvestYear[0])

setexpandePanel(expanded ? name : false)
  }

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleOpenModal = (value) => {
  setEle(value);
    setOpenModal(true);
  };
  
  function getModalStyle() {
    const top = 50;
    const left = 50;
  
    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
    };
  }





  const TableDropdown = ({type,dropdownlabel,value,dropclass, farmId}) => {
    const handlerChange = (event) => {
      if (type === "harvest") {
        setSelectedHarvestYear(event.target.value);
        props.actions.getTicketsForCounterParty(farmId, event.target.value, totalCount, pageNo, groupByValue,previousDaysvalue);
      } else if (type === "pageNo") {
        setPageNo(event.target.value);
        props.actions.getTicketsForCounterParty(farmId, selectedHarvestYear, totalCount, event.target.value, groupByValue, previousDaysvalue);
      } else if (type === "totalCount") {
        setTotalCount(event.target.value);
        props.actions.getTicketsForCounterParty(farmId, selectedHarvestYear, event.target.value, pageNo, groupByValue, previousDaysvalue);
      }
    };
    return  <div className={dropclass} onClick={(e)=>e.stopPropagation()}>
    <label> {dropdownlabel}</label>
    <Select className='select' value={type==="harvest"?selectedHarvestYear:type === "pageNo"?pageNo:totalCount} onChange={handlerChange}>
  {value && value.map((ele) => (
    <MenuItem key={ele} value={ele}>
      {ele}
    </MenuItem>
  ))}
</Select>
</div>
  }


      const Pagination = ({current,prev,next,total}) => {

        return <div className='dropdown-container'>
    
       <label className="pageNo"> {current + 1} - {total} of {total}</label> 
       <span className="Arrows" onClick={() => props.actions.getTicketsForCounterParty(farmId, selectedHarvestYear, totalCount, current - 1, groupByValue, previousDaysvalue)}>

{!prev && <FontAwesomeIcon icon={faArrowLeft} style={{ fontSize: "16px" }}/>}
</span>
        <span className="Arrows" onClick={() => props.actions.getTicketsForCounterParty(farmId, selectedHarvestYear, totalCount, current + 1, groupByValue, previousDaysvalue)}>
        {!next && <FontAwesomeIcon icon={faArrowRight} style={{ fontSize: "16px" }} />}
        </span>

        </div>
     }


      if (loader) {
        return <Loader />;
      }
  return (
    <div className="root">
      <div className="Refresh" onClick={()=>{
setexpandePanel('')
props.actions.getCounterPartyTicketList("Truckline");
props.actions.getCounterPartyDashboard(previousDaysvalue|| 7);


      }}><img width={26} src="https://img.icons8.com/?size=100&id=35635&format=png&color=40C057" alt="Refresh"/></div>
     <Modal
                                      open={openModal}
                                      onClose={handleCloseModal}
                                    >
                                      <div style={getModalStyle()}  className={classes.paper}>
                                        <div className="modal-header">
                                        <h2 id="simple-modal-title">Ticket Details:</h2>
                                        <span style={{cursor:"pointer"}}  onClick={()=>handleCloseModal()}> ❌ </span>
                                        </div>
                                        <p id="simple-modal-description">
                                            Ticket Number : <span> {ele.ticketNumber}</span> <br/>
                                            Origin Type :  <span>{ele.originType && ele.originType.type}</span> <br/>
                                            Load Date : <span>{moment(new Date(ele.loadDate)).format("lll")}</span>  <br/>
                                            Load Number Indicator: <span>{ele.loadNumber}</span> <br/>
                                            Commodity : <span>{ele.commodityResponseDTO && ele.commodityResponseDTO.name}</span> <br/>
                                            Delivery Destination : <span>{ele.destinationResponseDTO && ele.destinationResponseDTO.name}</span> <br/>
                                            Driver Name : <span>{ele.driverName}</span> <br/>
                                            Scale Shrink Bushels : <span>{ele.estimatedHomeScaleShrinkBushels}</span> <br/>
                                            Estimated Load Bushels : <span>{ele.fieldEstimatedLoadBushels}</span> <br/> 
                                            Estimated Load Weight : <span>{ele.fieldEstimatedLoadWeight}</span> <br/> 
                                            </p>
                                       
                                      </div>
                                    </Modal>
      {CounterPartyTicketList && CounterPartyTicketList.map((farm, index) => (
        <ExpansionPanel key={farm.name}
        expanded={expandePanel === farm.name}
        onChange={handleExapnaionPanel(farm.name,farm)}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} className={farm.parentId ==='-1'&&classes.exapansionPanel} onClick={() => {
            setSelectedHarvestYear(Math.max(...farm.harvestYear))
            setFarmId(farm.id)
            props.actions.getTicketsForCounterParty(farm.id,Math.max(...farm.harvestYear),totalCount,pageNo,groupByValue, previousDaysvalue)}}>
            <p className="heading">{farm.name}</p>
            
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
          <div className='MainContainer'>
          <div className='harvestYearDrop'>
          <TableDropdown type="harvest" dropdownlabel="Harvest Year" value= {farm.harvestYear} dropclass={"dropdown-container"} farmId={farm.id}   />
          </div>
          <div className="tableContainer">
         {ticketDataLoader?<div className='tableLoader'><Loader/></div>:<React.Fragment>
         {counterPartyTicketData && counterPartyTicketData.length > 0 ? <div className='Table-container'>
              <table className="custom-table">
                <tr>
                <th>Load Number Indicator</th>
                  <th>Ticket Number</th>
                  <th>Created Date</th>
                  <th>Status</th>
                  {/* <th>Origin Farm</th> */}
                  {/* <th>Load Date</th> */}
                  {/* <th>Delivery Destination</th> */}
                  <th>Commodity</th>
                  {/* <th>Truckline</th> */}
                  <th>Actions</th>
                </tr>
               {counterPartyTicketData  &&
                counterPartyTicketData.map(ele=>
                  <tr key ={ele.id} className='hover'>
                  <td>{ele.loadNumber}</td>
                  <td>
                  <div className='tcketNumber'>{ele.ticketNumber}</div>
                  
                  </td>
                  <td>{moment(new Date(ele.createdAt)).format("lll")}</td>
                  <td>{ele.status}</td>
                  {/* <td>{ele.originType && ele.originType.type}</td> */}
                  {/* <td>{ele.loadDate}</td> */}
                  {/* <td>{ele.destinationResponseDTO && ele.destinationResponseDTO.name}</td> */}
                  <td>{ele.commodityResponseDTO && ele.commodityResponseDTO.name}</td>
                  {/* <td>{ele.truckline && ele.truckline.name}</td> */}
                  <td>
                  <img alt="ticket" width={20} src={TicketPath} onClick={()=>handleOpenModal(ele)} />
            </td>
                </tr>
                )} 
              </table>
              <br/>
              <br/>

              <div className='page-container'>
              {pageData&&<Pagination current = {pageData.number} total ={pageData.totalPages} prev={pageData.first} next={pageData.last} />}
<TableDropdown type="totalCount" dropdownlabel="Records Per Page" value= {[1,2,3,4,5,6,7,8,9,10]} dropclass={"dropdown-container"} farmId={farm.id}   />
</div>
            </div>:
            <div className='Nodata-container'>
              {`No Data Available for this Farm in ${selectedHarvestYear} harvest year`}
            </div>}
         </React.Fragment>}
            </div>
            </div>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      ))}
    </div>
  );

}

function mapStateToProps(state, props) {
  return {
    CounterPartyTicketList: state.ticketReducer.CounterPartyTicketList,
    fetchingComplete: state.ticketReducer.fetchingComplete,

    pageCount: state.ticketReducer.pageCount,
    totalElements: state.ticketReducer.totalElements,
    ErrorMessage: state.globalserverMessage.ErrorMessage,
    SubFarmId: state.FarmManagementReducer.SubFarmId,
    MainFarmId: state.FarmManagementReducer.MainFarmId,
    selectedYear: state.harvestYearReducer.selectedYear,
    PrefencesList: state.preferencesReducer.PrefencesList,
    searchTerm: state.ticketReducer.searchTerm,
    counterPartyTicketData: state.ticketReducer.counterPartyTicketData,
    loader: state.ticketReducer.loader,
    ticketDataLoader: state.ticketReducer.ticketDataLoader,
    groupByValue: state.ticketReducer.groupByValue,
    previousDaysvalue: state.ticketReducer.previousDaysvalue,
    pageData: state.ticketReducer.pageData,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...ticketActions,
      },
      dispatch
    )
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CounterpartyTicketview));



// WEBPACK FOOTER //
// ./src/components/private/Tickets/CounterpartyTicketview.js